import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "skiRack"
const SkiRackIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5 7.4c0-.695.239-1.492.645-2.303.146-.294.304-.568.461-.813A5.64 5.64 0 0 1 20.8 4l.6-.8L19.8 2l-.6.8a9.593 9.593 0 0 0-.845 1.403C17.823 5.267 17.5 6.345 17.5 7.4v15h2v-15Zm-3 0c0-1.055-.323-2.133-.855-3.197A9.593 9.593 0 0 0 14.8 2.8l-.6-.8-1.6 1.2.6.8c.033.044.102.142.194.284.157.245.315.519.461.813.406.811.645 1.608.645 2.303v15h2v-15Zm-5-1h1v14h1v1h-1v1h-1c.884-.246 1.036-1.246.756-2.217a6.291 6.291 0 0 0-.756-1.597V6.4Zm-2 10.667V6.4h1v11.19a7.397 7.397 0 0 0-1-.523Zm-7 5.333H5l.5-1h2l.55 1h2.45l.5-1c.829 0 .124-1.67-.5-2.5-.617-.82-3-1.5-3-1.5l.55-6H3.5L2 21.4l.5 1Z"
      />
    </svg>
  )
}
export default SkiRackIcon
